export default {
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.findPassword': '忘记密码',
  'menu.account.logout': '退出登录',
  'menu.about': '关于',
  'menu.product':'产品',
  'menu.product.challenge-rules':'挑战规则',
  'menu.product.month-challenge':'月赛挑战',
  'menu.product.elite-competition':'精英赛',
  'menu.product.personal-challenge':'个人挑战',
  'menu.develop':'拓展',
  'menu.develop.partnership-program':'合伙人计划',
  'menu.develop.trader-recruitment':'招募交易员',
  'menu.download':'下载',
  'menu.FAQ':'FAQ',
  'menu.FAQ.list':'FAQ列表',
  'menu.account': '个人中心',
  'menu.account.personal': '个人资料',
  'menu.account.instrument-panel': '仪表盘',
  'menu.account.purchaseEvaluation': '购买评估',
  'menu.account.earn': '推广',
  'menu.account.payout': '资产',
  'menu.account.certificate': '证书',
  'menu.account.paymentRecords': '付费记录',
  'menu.account.contactUs': '联系我们',
  'menu.account.evaluation': '评估',
  'menu.account.orderDetail': '订单详情',



  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
